import React from "react";
import { formatRangeVal, getExposure, bookClass, bookText, isSuspended, useRangeToggle } from "../../casinoComponents/userSiteLastResult/refUtils";
import { RangeIcon, RefRemark } from "../../casinoComponents/userSiteLastResult/refBits";
import Collapse from "../../../components/Collapse";

const BASE = import.meta.env.BASE_URL;
const SUIT = `${BASE}img/cardIcons`;
const CARD = (c) => `${BASE}img/cards/${c}.png`;

/**
 * 20-20 D T L (dtl20) bet area in the reference markup (inside .casino-detail; reference isTablet template):
 *   .teen1daycasino-container.d-none-small >
 *     .teen1dayleft  (D/T/L header + Winner, Black, Red, Odd, Even, A, 2, 3, 4)
 *     .teen1daycenter
 *     .teen1dayright (D/T/L header + 5 … 10, J, Q, K)
 *   each row: .casino-nation-name + .dtl20info (i) range + 3 × .casino-bl-box (Dragon / Tiger / Lion)
 *   + .casino-remark. Markets = sub sorted by sr: 0-17 Dragon, 18-35 Tiger, 36-53 Lion.
 */
export default function DtlLiveTable({ raw = {}, exposures = {}, gameType = "dtl20" }) {
  const [open, toggle] = useRangeToggle();
  const sub = Array.isArray(raw?.sub) ? raw.sub : [];
  const main = sub
    .filter((s) => !s?.subtype || s.subtype === gameType)
    .sort((a, b) => Number(a?.sr) - Number(b?.sr));

  const header = (cls) => (
    <div className={cls}>
      <div className="casino-nation-name no-border">
        <div />
      </div>{" "}
      <div className="casino-bl-box">
        <b>D</b>
      </div>{" "}
      <div className="casino-bl-box">
        <b>T</b>
      </div>{" "}
      <div className="casino-bl-box">
        <b>L</b>
      </div>
    </div>
  );

  const box = (item) => {
    const exp = getExposure(exposures, item?.nat);
    const susp = isSuspended(item);
    return (
      <div className="casino-bl-box">
        {/* padlock at the top only when the cell has a book (no book → centred) */}
        <div className={`back casino-bl-box-item${susp ? (exp ? " suspended lock-top" : " suspended") : ""}`}>
          <span className="casino-box-odd">{item?.b}</span>{" "}
          <span className={`casino-book ${bookClass(exp)}`}>{bookText(exp)}</span>
        </div>
      </div>
    );
  };

  const row = (key, name, rangeItem, id, items) => (
    <div className="casino-box-row" key={key}>
      {name}{" "}
      <div className="float-right dtl20info">
        <RangeIcon id={id} open={!!open[id]} onToggle={toggle} withExpanded={false} collapsedClass={false} />{" "}
        <Collapse id={id} open={!!open[id]} className="icon-range">
          {"\n                                                R:"}
          <span>{formatRangeVal(rangeItem?.min)}</span>-<span>{formatRangeVal(rangeItem?.max)}</span>
        </Collapse>
      </div>{" "}
      {box(items[0])} {box(items[1])} {box(items[2])}
    </div>
  );

  const imgName = (srcs) => (
    <div className="casino-nation-name casino-card-img">
      <span>
        {srcs.map((src, i) => (
          <React.Fragment key={src}>
            {i > 0 && " "}
            <img src={src} alt="" />
          </React.Fragment>
        ))}
      </span>
    </div>
  );

  const leftName = (s) => {
    if (s === 2) return imgName([`${SUIT}/spade.png`, `${SUIT}/club.png`]);
    if (s === 3) return imgName([`${SUIT}/heart.png`, `${SUIT}/diamond.png`]);
    if (s >= 6) return imgName([CARD(["A", "2", "3", "4"][s - 6])]);
    return (
      <div className="casino-nation-name">
        <b>{String(main[s - 1]?.nat ?? "").split(" ")[0]}</b>
      </div>
    );
  };
  const rightCard = (s) => (s === 7 ? "J" : s === 8 ? "Q" : s === 9 ? "K" : String(s + 4));

  const S = [1, 2, 3, 4, 5, 6, 7, 8, 9];
  return (
    <>
      <div className="teen1daycasino-container d-none-small">
        <div className="teen1dayleft">
          {header("casino-box-row mb-0")}{" "}
          {S.map((s, i) => row(s, leftName(s), main[s - 1], `demo-l-${i}`, [main[s - 1], main[s + 17], main[s + 35]]))}
        </div>{" "}
        <div className="teen1daycenter" />{" "}
        <div className="teen1dayright">
          {header("casino-box-row mb-0 d-none-small")}{" "}
          {S.map((s, i) =>
            row(s, imgName([CARD(rightCard(s))]), main[s + 8], `demo-r-${i}`, [main[s + 8], main[s + 26], main[s + 44]])
          )}
        </div>
      </div>{" "}
      <RefRemark remark={raw?.remark} />
    </>
  );
}
